// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/slick-theme.css
// module id = 1283
// module chunks = 34